import { GetServerSidePropsContext } from 'next'

import { serverSidePropsFor } from '@/utils/helpers.server'

import DecksPage from '..'

export const getServerSideProps = async (context: GetServerSidePropsContext) =>
  serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/decks/${context.query.commander}/${context.query.tag}.json`,
  )

export default DecksPage
